// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-indicator {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #138fb8;
}

.status-indicator.small {
  height: 8px;
  width: 8px;
  display: inline-block;
  margin-left: 4px;
  margin-right: 4px;
}

.status-indicator.pending {
  background: #138fb8;
  animation: pulse infinite 2s;
}

.status-indicator.warning {
  background: #edbb61;
}

.status-indicator.success,
.status-indicator.complete {
  background: #01a166;
}

.status-indicator.error {
  background: #ff0000;
}

@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
    opacity: 0.55;
  }

  50% {
    transform: scale3d(1.2, 1.2, 1.2);
    opacity: 1;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 0.55;
  }
}
`, "",{"version":3,"sources":["webpack://./datasets/dataset-details/dataset-details.global.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,aAAa;EACf;AACF","sourcesContent":[".status-indicator {\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background: #138fb8;\n}\n\n.status-indicator.small {\n  height: 8px;\n  width: 8px;\n  display: inline-block;\n  margin-left: 4px;\n  margin-right: 4px;\n}\n\n.status-indicator.pending {\n  background: #138fb8;\n  animation: pulse infinite 2s;\n}\n\n.status-indicator.warning {\n  background: #edbb61;\n}\n\n.status-indicator.success,\n.status-indicator.complete {\n  background: #01a166;\n}\n\n.status-indicator.error {\n  background: #ff0000;\n}\n\n@keyframes pulse {\n  from {\n    transform: scale3d(1, 1, 1);\n    opacity: 0.55;\n  }\n\n  50% {\n    transform: scale3d(1.2, 1.2, 1.2);\n    opacity: 1;\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n    opacity: 0.55;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
